<template>
    <div class="views-content--profile">

        <banner-split :data="data.hero"></banner-split>

         <!-- elements -->
        <div v-for="element in data.elements" :key="element.id">
            <component :is="element.vueName" :data="element"/>
        </div>

    </div>
</template>

<script>

    import { BannerSplit } from "../components";

     // elements
    import { ElementAccordion,ElementBackgroundImage, ElementContent, ElementCTA, ElementColours,ElementImage, ElementLinks, ElementImages, ElementProducts, ElementSplitSlider, ElementTiles, ElementVideo, ElementPercentage, ElementForm} from "../components";


    export default {
        name: "v-sample",
        components: {
            BannerSplit,
            ElementAccordion,
            ElementBackgroundImage,
            ElementColours,
            ElementContent,
            ElementCTA,
            ElementLinks,
            ElementImages,
            ElementImage,
            ElementProducts,
            ElementSplitSlider,
            ElementTiles,
            ElementVideo,
            ElementPercentage,
            ElementForm
        },
        props: {
            data: {
                type: Object
            }
        },
        data () {
            return {
                
            }
        },
        created() {

        }
    };
</script>

<style lang="scss" scoped>

</style>

